export const dogsAndCatsColors = [
    "Black",
    "White",
    "Brown",
    "Chocolate", 
    "Fawn",
    "Grey",
]

export const generalColors = [
    "Black",
    "White",
    "Brown",
    "Chocolate",
    "Fawn",
    "Grey",
    "Orange",
]